// utils/urgentCount.js

/**
 * Returns the number of Communication resources marked with priority "urgent".
 * 
 * @param {Array} messages - Array of FHIR Communication resources
 * @returns {number} - Count of urgent messages
 */
export const getUrgentCount = (messages = []) => {
  return messages.filter(comm =>
    comm.priority?.toLowerCase() === "urgent"
  ).length;
};